import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import Categories from "../components/categories/Categories";
import PopularProduct from "../components/popularProduct/PopularProduct";
import OrganicProductCard from "../components/organicProductCard/OrganicProductCard.js";
import Slider from "../components/slider/Slider";
import { useHomeProducts } from "../apiHooks/useHomeProducts.js";
import { useTranslation } from "react-i18next";

function Home() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { featured, newArrivals, flashSale, bestsellers, isLoading, isError } =
    useHomeProducts();
  const getProductArray = (products) => {
    if (Array.isArray(products)) return products;

    if (Array.isArray(products?.data)) return products.data;

    if (Array.isArray(products?.data?.data)) return products.data.data;

    if (Array.isArray(products?.data?.products)) return products.data.products;

    return [];
  };

  const hasProducts = (products) => getProductArray(products).length > 0;

  const sections = [
    {
      products: flashSale,
      title: t('home.flashSale'),
      description: t('home.flashSaleDesc'),
      showOnlyIfHasProducts: true,
      isFlashSale: true,
    },
    {
      products: bestsellers,
      title: t('home.bestSelling'),
      description: t('home.bestSellingDesc'),
      showOnlyIfHasProducts: true,
    },
    {
      products: newArrivals,
      title: t('home.newArrivals'),
      description: t('home.newArrivalsDesc'),
      showOnlyIfHasProducts: true,
    },
    {
      products: featured || [],
      title: t('home.featured'),
      description: t('home.featuredDesc'),
      showOnlyIfHasProducts: false,
    },
  ];
  return (
    <div className="bg-gray-50">
      <Helmet>
        <title>Palli Market - Fresh Groceries & Daily Essentials | Best Prices</title>
        <meta name="description" content="Shop fresh groceries, vegetables, dairy, snacks and daily essentials at Palli Market. Fast delivery, genuine products, and best prices guaranteed." />
        <link rel="canonical" href="https://pallimarket.bd/" />
        <meta property="og:title" content="Palli Market - Fresh Groceries & Daily Essentials" />
        <meta property="og:description" content="Shop fresh groceries, vegetables, dairy, snacks and daily essentials at Palli Market. Fast delivery, genuine products, and best prices guaranteed." />
        <meta property="og:url" content="https://pallimarket.bd/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Palli Market - Fresh Groceries & Daily Essentials" />
        <meta name="twitter:description" content="Shop fresh groceries, vegetables, dairy, snacks and daily essentials at Palli Market. Fast delivery, genuine products, and best prices guaranteed." />
      </Helmet>
      <div className="min-h-screen">
        <div className="bg-white">
          <div className="mx-auto py-3 sm:py-5 max-w-screen-2xl px-3 sm:px-10">
            <div className="flex w-full">
              <div className="w-full">
                <Slider />
              </div>
            </div>
            <OrganicProductCard />
          </div>
        </div>

        <Categories />

        <>
          {sections.map((section) => {
            const productList = getProductArray(section.products);

            if (section.showOnlyIfHasProducts && productList.length === 0) {
              return null;
            }

            return (
              <PopularProduct
                key={section.title}
                products={productList}
                title={section.title}
                description={section.description}
                isFlashSale={section.isFlashSale}
              />
            );
          })}
        </>

        {/* View All Products Button */}
        {!isLoading && (
          <div className="flex justify-center my-6 sm:my-10 pb-4 sm:pb-6">
            <button
              onClick={() => navigate("/shop")}
              className="px-8 py-3 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold rounded-full transition-colors duration-200 shadow-sm hover:shadow-md"
            >
              {t('home.viewAll')}
            </button>
          </div>
        )}
        {/* <FastDeliveryCard /> */}
        {/* <LatestDiscountedProduct /> */}
      </div>
    </div>
  );
}

export default Home;
